export function PortalFooter(): React.ReactElement {
  return (
    <footer className="bg-[var(--color-header)] text-white">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 sm:grid-cols-2 lg:grid-cols-4 sm:px-8">
        <div className="lg:col-span-2">
          <img src="/t3-logo-white.png" className="h-10 w-auto" alt="T3 Tech Partners" />
          <p className="mt-5 max-w-sm text-sm text-white/60">
            Helping MSPs get more work done — without having to hire.
          </p>
        </div>
        <div>
          <div className="text-xs font-semibold uppercase tracking-widest text-white">Company</div>
          <div className="mt-2 h-0.5 w-10 bg-[var(--color-t3-blue)]"></div>
          <ul className="mt-4 space-y-3 text-sm">
            <li><a href="https://t3techpartners.com/about" target="_blank" rel="noreferrer" className="text-white/70 hover:text-white">About Us</a></li>
            <li><a href="https://t3techpartners.com/our-team" target="_blank" rel="noreferrer" className="text-white/70 hover:text-white">Our Team</a></li>
            <li><a href="https://t3techpartners.com/services" target="_blank" rel="noreferrer" className="text-white/70 hover:text-white">Services</a></li>
          </ul>
        </div>
        <div>
          <div className="text-xs font-semibold uppercase tracking-widest text-white">Follow</div>
          <div className="mt-2 h-0.5 w-10 bg-[var(--color-t3-blue)]"></div>
          <div className="mt-4 flex gap-2">
            <a href="https://www.facebook.com/t3techpartners" target="_blank" rel="noreferrer" className="grid h-9 w-9 place-items-center rounded-md bg-white/10 hover:bg-white/20" aria-label="Facebook">
              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d="M9 8h-3v4h3v12h5V12h3.642L18 8h-4V6.333C14 5.378 14.192 5 15.115 5H18V0h-3.808C10.596 0 9 1.583 9 4.615V8z"/></svg>
            </a>
            <a href="https://www.linkedin.com/company/t3-tech-partners" target="_blank" rel="noreferrer" className="grid h-9 w-9 place-items-center rounded-md bg-white/10 hover:bg-white/20" aria-label="LinkedIn">
              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.761 0 5-2.239 5-5v-14c0-2.761-2.239-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
            </a>
            <a href="https://www.youtube.com/@t3techpartners" target="_blank" rel="noreferrer" className="grid h-9 w-9 place-items-center rounded-md bg-white/10 hover:bg-white/20" aria-label="YouTube">
              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/></svg>
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 py-5 text-center text-xs text-white/50 sm:px-8">
          © {new Date().getFullYear()} T3 Tech Partners. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
}
